import React, { useContext, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { embedDashboard } from '@superset-ui/embedded-sdk';

import ContainerBaseLoading from '../../../components/containers/baseLoading/containerBaseLoading.component';
import LenguajeContext from '../../../context/Lenguaje/lenguajeContext';
import { RequestFetch } from '../../../utils/Requests/requests.Controller';

import './supersetReport.scss';

const SupersetReport = () => {
    const { clientName, reportKey } = useParams();
    const { stateLanguage } = useContext(LenguajeContext);
    const dashboardContainer = useRef(null);
    const [controlsPage, setControlsPage] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        let controls = {};

        if (stateLanguage.lenguaje != 0) {
            stateLanguage.lenguaje.forEach(page => {
                if (page.path == 'controls' || page.path == 'reports') {
                    page.webcontrolspages.forEach(control => {
                        controls[control.idHtml] = control.languagewebcontrols[0];
                    });
                }
            });

            setControlsPage(controls);
        }
    }, [stateLanguage]);

    useEffect(() => {
        if (!reportKey || !dashboardContainer.current) return;

        let active = true;

        const loadDashboard = async () => {
            setIsLoading(true);
            setError('');
            if (dashboardContainer.current) {
                dashboardContainer.current.innerHTML = '';
            }
                
            try {
                const supersetRequest = new RequestFetch(`Superset/reports/${reportKey}/token`);

                const response = await supersetRequest.getItem({tenant: clientName});

                if (!active || !response?.data?.data) {
                    if (active) setError('No fue posible obtener la configuración del reporte.');
                    return;
                }

                const {token, dashboardId, supersetDomain } = response.data.data;

                if (!token || !dashboardId || !supersetDomain) {
                    setError('La configuración del reporte está incompleta.');
                    return;
                }

                await embedDashboard({ id: dashboardId, supersetDomain, mountPoint: dashboardContainer.current,
                    fetchGuestToken: () => Promise.resolve(token),
                    dashboardUiConfig: {
                        hideTitle: false,
                        hideChartControls: false,
                        hideTab: false,
                        filters: {
                            visible: true,
                            expanded: false
                        }
                    }
                });
            } catch (error) {
                if (active) {
                    console.error('Error cargando dashboard de Superset:', error);
                    setError('No fue posible cargar el reporte.');
                }
            } finally {
                if (active) setIsLoading(false);
            }
        };

        loadDashboard();

        return () => {
            active = false;

            if (dashboardContainer.current) {
                dashboardContainer.current.innerHTML = '';
            }
        };
    }, [clientName, reportKey]);

    return (
        <div className="superset-report-page">
            {/* <h2>{controlsPage?.lblAdminiOperationsReport?.value}</h2> */}

            {isLoading && <ContainerBaseLoading />}

            {error && (
                <div className="superset-report-error">
                    {error}
                </div>
            )}

            <div
                ref={dashboardContainer}
                className="superset-report-container"
            />
        </div>
    );
};

export default SupersetReport;